<template>
  <div>
    <el-drawer :visible.sync="drawer" :direction="direction" :before-close="handleClose" size="70%">
      <template slot="title">
        <p class="title">{{currentrow.orderNo}}</p>
      </template>
      <el-table :data="gridData">
        <el-table-column property="area" label="检修专业" width="150"></el-table-column>
        <el-table-column property="deviceLedger" label="设备位号" width="200"></el-table-column>
        <el-table-column property="deviceName" label="设备名称"></el-table-column>
        <el-table-column property="constructionFactory" label="施工单位"></el-table-column>
        <el-table-column property="gmtCreate" label="创建时间"></el-table-column>
      </el-table>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="进度" name="a">
          <el-steps :active="1" align-center>
            <el-step title="步骤 1">
              <template slot="description">
                <p class="title">15678919489</p>
              </template>
            </el-step>
            <el-step title="步骤 2">
              <template slot="description">
                <p class="title">15678919489</p>
              </template>
            </el-step>
            <el-step title="步骤 3">
              <template slot="description">
                <p class="title">15678919489</p>
              </template>
            </el-step>
          </el-steps>
          <el-collapse v-model="activeNames" @change="handleChange">
            <el-collapse-item title="维修内容" name="1">
              <div>{{currentrow.serviceContext}}</div>
            </el-collapse-item>
            <el-collapse-item title="备注" name="2">
              <div>控制反馈：通过界面样式和交互动效让用户可以清晰的感知自己的操作；</div>
              <div>页面反馈：操作后，通过页面元素的变化清晰地展现当前状态。</div>
            </el-collapse-item>
          </el-collapse>
        </el-tab-pane>
        <el-tab-pane label="日志" name="b">定时任务补偿</el-tab-pane>
      </el-tabs>
    </el-drawer>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  data() {
    return {
      drawer: true,
      activeNames: "1",
      direction: "rtl",
      chooseItem: 0,
      active: "1",
      value: [0, 10], //京都条
      activeName: "a",
      gridData: [], //表格信息
      dialogTableVisible: false,
      dialogFormVisible: false,
      formLabelWidth: "120px",
    };
  },
  props: ["currentid", "currentrow", "isshow"],
  methods: {
    handleClick(tab, event) {
      // console.log(tab, event);
    }, //进度条
    handleClose(done) {
      this.$emit("ifClose");
    }, //抽屉关闭
    handleChange() {}, //手风琴
  },
  created() {
    this.gridData = [this.currentrow];
  },
};
</script>
<style scoped>
h2 {
  text-align: start;
}
.title {
  text-align: start;
}
</style>